export default __webpack_public_path__ + "static/media/school1.9d857fd8.jpg";